<template>
  <div class="serviceQcode_ui" v-if="isServiceQcode">
    <div class="serviceQcode">
      <div class="serviceQcodeTitle">
        官方客服
      </div>
      <div class="serviceQcodeImgBox">
          <img :src="qrCode" >
      </div>
      <div class="serviceQcodeTip">长按识别二维码添加咨询喔</div> <i @click="closeQrcode" class="closeServiceQcode iconfont iconshanchu1"></i>
    </div>
  </div>
</template>
<script>
var config = {};
import { getStorage } from "@/utils/wxuser";
export default {
  data() {
    return {
        isServiceQcode:false,
        qrCode:''
    };
  },
  props: ["qrCodeUrl"],
  methods: {
      closeQrcode(){
          this.isServiceQcode = false
      }
  },
  mounted(){
      if(this.qrCodeUrl){
        this.qrCode =this.qrCodeUrl
      }
      else if(getStorage('isQrCode')){
          this.qrCode = getStorage('isQrCode')
      }
      
  }
}
</script>
<style lang="less">
@import url("~@/styles/base.less");
@import url("~@/styles/mixin.less");
.serviceQcode_ui {
  position: fixed;
  z-index: 1200;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  .serviceQcode {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -1.2rem;
    width: 6.266667rem;
    height: 6.666667rem;
    background: #fff;
    border-radius: 10px;
    padding: 18px;
    transform: translate(-50%, -50%);
    .serviceQcodeTitle {
      height: 22px;
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #333;
      letter-spacing: 0;
      font-weight: 400;
      text-align: center;
      line-height: 22px;
      margin-bottom: 0.4rem;
    }
    .serviceQcodeImgBox {
      width: 3.733333rem;
      height: 3.733333rem;
      margin: 0 auto;
      margin-bottom: 0.4rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .serviceQcodeTip {
      height: 20px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #999;
      letter-spacing: 0;
      font-weight: 400;
      text-align: center;
    }
  }
  .closeServiceQcode {
    left: 50%;
    position: absolute;
    bottom: -1.2rem;
    font-size: 28px;
    transform: translate(-50%,0);
    color: #fff;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/serviceQcode.vue